import styled from 'styled-components';
import { FONTS, COLORS } from '@stelecom/ui-react/assets/js/constants';
import Menu from '~/src/components/Menu';

export const breakpoints = {
    sDesktop: '1365px',
    tablet: '1023px',
    mobile: '767px',
};

export const IndexContainerInfo = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 50px;

    @media(max-width: 640px) {
        margin-bottom: 20px;
    }
`;

export const TariffTitle = styled.h1`
    width: 100%;
    margin: 30px 0;
    ${FONTS.H2};
    color: ${COLORS.black};
    span {
        display:inline-block;
        width: 100%;
        ${FONTS.XXL};
        margin-top: 10px;
    }
    @media (max-width: 530px) {
        ${FONTS.H3};
    }
`;

export const Wrapper = styled.div`
    display: block;
    overflow: hidden;
    width: 100%;
`;

export const Control = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 38px;
    cursor: pointer;
    width: 100%;
`;

export const Checkbox = styled.div`
    display: block;
    position: relative;
    width: 20px;
    height: 20px;
    border: 2px solid ${COLORS.grey};
    border-radius: 4px;
    &:after {
      display: block;
      content: '';
      position: absolute;
      width: 12px;
      height: 6px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 4px;
      margin: auto;
      border-left: 2px solid ${COLORS.darkGrey};
      border-bottom: 2px solid ${COLORS.darkGrey};
      transform: rotate(-45deg);
      transition: 0.3s;
      opacity: ${p => p.checked ? '1' : '0'};
    }
`;

export const Text = styled.div`
    display: block;
    padding-left: 12px;
    ${FONTS.S};
    color: ${COLORS.darkGrey};
`;

export const Actions = styled.div`
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;

    @media (max-width: ${breakpoints.mobile}) {
        flex-direction: column-reverse;
        align-items: flex-start;
    }
`;

export const Radiocontrol = styled.div`
    width: auto;
    flex-wrap: nowrap;

    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
        width: 1px;
        height: 1px;
        display: none;
        position: absolute;
        left: -9999px;
    }

    [type="radio"]:disabled + label {
        opacity: .5;
        pointer-events: none;
        border: none;
    }

    label {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        height: 48px;
        ${FONTS.Medium};
        color: ${COLORS.black};
        background: ${COLORS.white};
        border: 1px solid ${COLORS.outlineGrey};
        border-radius: 4px;
        white-space: nowrap;
        cursor: pointer;
        transition: all 0.2s ease;

        &:first-of-type {
            width: 232px;
            padding-right: 40px;

            &:before {
                content: '';
                position: absolute;
                width: 30px;
                height: 25px;
                top: 50%;
                left: 13px;
                transform: translateY(-50%);
                background: url('/static/images/icons/bundles-case.svg') 0 0 / cover no-repeat;
            }

            @media (max-width: ${breakpoints.sDesktop}) {
                width: 187px;
                padding-right: 27px;

                &:before {
                    width: 21px;
                    height: 17px;
                    left: 24px;
                }
            }

            @media (max-width: ${breakpoints.mobile}) {
                width: 143px;
                padding-right: 10px;

                &:before {
                    width: 18px;
                    height: 15px;
                    left: 11px;
                }
            }
        }

        &:last-of-type {
            width: 191px;
            margin-left: 10px;
            padding-right: 45px;

            &:before {
                content: '';
                position: absolute;
                width: 30px;
                height: 20px;
                top: 50%;
                left: 13px;
                transform: translateY(-50%);
                background: url('/static/images/icons/prod-internet.svg') 0 0 / cover no-repeat;
            }

            @media (max-width: ${breakpoints.sDesktop}) {
                width: 151px;
                margin-left: 8px;
                padding-right: 27px;

                &:before {
                    width: 21px;
                    height: 14px;
                    left: 24px;
                }
            }

            @media (max-width: ${breakpoints.mobile}) {
                width: 135px;
                padding-right: 25px;

                &:before {
                    left: 11px;
                }
            }
        }

        @media (max-width: ${breakpoints.sDesktop}) {
            ${FONTS.S};
        }

        @media (max-width: ${breakpoints.mobile}) {
            ${FONTS.XS};
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-bottom: 12px;
    }

    [type="radio"]:checked + label {
        border: 1px solid ${COLORS.middleGray};
    }
`;

export const TariffFilterTabs = styled(Menu)`
    margin-top: 0;
`;
